import i18next from "i18next";
import { ref } from "vue";

/**
 * Translations for Vue components.
 *
 * i18next itself is initialised by app.ts at startup. `t()` reads a reactive counter,
 * so components re-render once the translations have loaded (or the language changes).
 *
 * Several translations contain markup (e.g. line breaks), so render them with
 * v-html="t('key')" rather than {{ t('key') }}. They come from our own locale files.
 */
const version = ref(0);
const bump = () => { version.value++; };
i18next.on("initialized", bump);
i18next.on("loaded", bump);
i18next.on("languageChanged", bump);

export function t(key: string, options?: Record<string, unknown>): string {
    version.value; // dependency for re-rendering
    // Empty until app.ts has initialised i18next (before that, t() returns undefined)
    if (!i18next.isInitialized) return "";
    return i18next.t(key, options) as string;
}

export { i18next };
